import { type MouseEvent } from "react";
import { LOCAL_AEO_STRATEGY_SPECS } from "@/data/localAeoStrategySpec";

function trustedPreviewHtml(html: string) {
  // This string comes only from the versioned, reviewed preview specification.
  // Strip executable markup defensively before rendering it in the local preview.
  // The supplied modules deliberately retain publish/reviewer placeholders in
  // their source record. A block containing one stays hidden until Modi gives
  // the real value; preview must never display an unfinished credential.
  return html
    .replace(/<p\b[^>]*>[\s\S]*?\[PLACEHOLDER:[^\]]+\][\s\S]*?<\/p>/gi, "")
    .replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, "")
    .replace(/\son\w+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, "")
    .replace(/\sdata-event\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, "")
    .replace(/javascript\s*:/gi, "");
}

function onPreviewAction(event: MouseEvent<HTMLElement>) {
  const target = (event.target as HTMLElement).closest<HTMLButtonElement>('button[type="button"]');
  if (!target || typeof window === "undefined") return;
  // The supplied evidence modules have print controls. They remain functional in
  // preview, but they intentionally emit no new analytics until Modi approves R5.
  event.preventDefault();
  window.print();
}

export function StrategyHtml({ html, className = "" }: { html: string; className?: string }) {
  return <div className={`local-aeo-strategy prose prose-stone max-w-none ${className}`} onClick={onPreviewAction} dangerouslySetInnerHTML={{ __html: trustedPreviewHtml(html) }} />;
}

export function LocalAeoFactsBlock({ route }: { route: string }) {
  const spec = LOCAL_AEO_STRATEGY_SPECS[route];
  if (!spec) return null;
  return <StrategyHtml html={spec.factsHtml} className="my-10 border-y border-[#E8E4DF] bg-[#FFF9F2] px-5 py-8" />;
}

export function LocalAeoModuleBlock({ route }: { route: string }) {
  const spec = LOCAL_AEO_STRATEGY_SPECS[route];
  if (!spec?.moduleHtml) return null;
  return <StrategyHtml html={spec.moduleHtml} className="my-10 border-y border-[#E8E4DF] bg-[#F7F5F2] px-5 py-8" />;
}

export function LocalAeoPlanFactsBlock({ route }: { route: string }) {
  const spec = LOCAL_AEO_STRATEGY_SPECS[route];
  if (!spec) return null;
  return <StrategyHtml html={spec.factsHtml} className="prose-invert border-y border-white/15 bg-white/[0.04] px-5 py-8 text-white [&_a]:text-[#FFB25F] [&_a]:underline [&_h2]:text-white [&_h3]:text-white [&_li]:text-white/75 [&_p]:text-white/75" />;
}
